import React, { useState, useEffect } from "react";
import Api from "../services/api";
import styles from "../styles/SelectStatus.module.css";

export default function SelectStatus({
  search,
  setSearch,
  isOpenStatus,
  setIsOpenStatus,
}) {
  const [list, setList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const totalList = list.length;

  useEffect(() => {
    loadStatus();
  }, []);

  function loadStatus() {
    Api.get("/reservas/status")
      .then((response) => {
        setList(response.data);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  const handleCheckboxChange = (value) => {
    if (search.status.includes(value)) {
      setSearch({
        ...search,
        status: search.status.filter((val) => val !== value),
      });
    } else {
      setSearch({
        ...search,
        status: [...search.status, value],
      });
    }
  };

  let rows =
    list &&
    list.map((status, index) => {
      return (
        <li key={index}>
          <input
            type="checkbox"
            checked={search.status.includes(status.id)}
            onChange={() => handleCheckboxChange(status.id)}
          />{" "}
          <span>{status.nome}</span>
        </li>
      );
    });

  return (
    <>
      <button
        className={styles.btn}
        type="button"
        onClick={() => setIsOpenStatus(!isOpenStatus)}
      >
        {`${search.status.length} de ${totalList} selecionado`}
      </button>
      <div
        className={`${styles.statusbox} ${isOpenStatus ? styles.opened : undefined}`}
      >
        <ul>{rows}</ul>
      </div>
    </>
  );
}
